import { createAction, createReducer } from '@reduxjs/toolkit';

import type { ActivityEvent } from '../../api/activity.api.js';

const CAP = 100;

export interface PendingActivityEventsState {
  items: ActivityEvent[];
}

const initialState: PendingActivityEventsState = { items: [] };

export const activityEventPushed = createAction<ActivityEvent>('pendingActivityEvents/pushed');
export const activityEventRemoved = createAction<string>('pendingActivityEvents/removed');
export const activityEventsHydrated = createAction<ActivityEvent[]>('pendingActivityEvents/hydrated');

const pendingActivityEventsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(activityEventPushed, (state, action) => {
      const incoming = action.payload;
      if (incoming.reviewStatus) return;
      const existing = state.items.findIndex((e) => e.id === incoming.id);
      if (existing >= 0) {
        state.items[existing] = incoming;
        return;
      }
      state.items.unshift(incoming);
      if (state.items.length > CAP) state.items.length = CAP;
    })
    .addCase(activityEventRemoved, (state, action) => {
      state.items = state.items.filter((e) => e.id !== action.payload);
    })
    .addCase(activityEventsHydrated, (state, action) => {
      state.items = action.payload.filter((e) => !e.reviewStatus).slice(0, CAP);
    });
});

export default pendingActivityEventsReducer;
